<form #referenceForm="ngForm">

  <div class="row">
    <div class="col-12">
      <div class="candidateDetails">
        <p><strong>Candidate Name:</strong> {{model.applicantName}}</p>
        <p><strong>Job:</strong> {{model.title}}</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <app-custom-applicant-element-renderer [model]="element" [hidden]="false"
                                             (applicantElementUpdated)="updateCustomApplicantElement($event);"></app-custom-applicant-element-renderer>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12 text-right">
      <button class="btn btn-primary" mdbWavesEffect [disabled]="!referenceForm.form.valid || hasSubmitted || !canSave" (click)="save()">Send</button>
    </div>
  </div>
</form>



<div mdbModal #thankYouModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="thankYouModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">Thank you</h4>
      </div>
      <div class="modal-body" *ngIf="submittedPrior">Your response to this request has already been received.</div>
      <div class="modal-body" *ngIf="!submittedPrior">Your submission has been received.</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" aria-label="Close" (click)="thankYouModal.hide()" mdbWavesEffect>Ok</button>
      </div>
    </div>
  </div>
</div>
